<template>
    	<v-app>
            <div class="d-flex" v-if="logged">
                <NavBar />
            </div>
            <LogIn v-else />
        </v-app>
</template>

<script setup>
    import jQuery from 'jquery';
    import { getCurrentInstance, onMounted, ref, provide } from 'vue';
    import { useI18n } from 'vue-i18n';
    import LogIn from './components/LogIn.vue';
    import NavBar from './components/NavBar.vue';
    import { useLogStore } from '@/stores/logStore.js';
    import { useUserStore } from '@/stores/userStore.js';

    const $ = jQuery;
    window.$ = $;

    const { t } = useI18n();
    const appInstance = getCurrentInstance();
    const logStore = useLogStore();
    const userStore = useUserStore();

    const logged = ref(userStore.isLogged());
    const postHeaders = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
    const assortUrl = import.meta.env.VITE_ASSORT_URL;
    const backOfficeUrl = import.meta.env.VITE_BACKOFFICE_URL;
    const pspUrl = import.meta.env.VITE_PSP_URL;
    const portalUrl = import.meta.env.VITE_PORTAL_URL;
    const urlWebAPI = getUrlWebAPI(import.meta.env.NODE_ENV, import.meta.env.VITE_WEBAPI_URL);
    const isLocalEnv = import.meta.env.VITE_ENV === 'local';
    const isDevEnv = import.meta.env.VITE_ENV === 'development';
    const isPreprodEnv = import.meta.env.VITE_ENV === 'qa';
    const isProdEnv = import.meta.env.VITE_ENV === 'production';
    const vueVersion = import.meta.env.VITE_PACKAGE_VERSION;
    const webApiVersion = ref(null);

    onMounted(() => {
        document.title = import.meta.env.VITE_TITLE;
        checkLastLoginDate();
        userStore.setLocale(appInstance.proxy);
    });

    provide('assortUrl',assortUrl);
    provide('backOfficeUrl', backOfficeUrl);
    provide('pspUrl', pspUrl);
    provide('portalUrl', portalUrl);
    provide('urlWebAPI', urlWebAPI);
    provide('isLocalEnv', isLocalEnv);
    provide('isDevEnv', isDevEnv);
    provide('isPreprodEnv', isPreprodEnv);
    provide('isProdEnv', isProdEnv);
    provide('vueVersion', vueVersion);
    provide('webApiVersion', webApiVersion);
    provide('updateRefreshState', updateRefreshState);
    provide('translate', translate);
    provide('getFormBody', getFormBody);
    provide('sleep', sleep);

    function getUrlWebAPI(env, webApiUrl) {
                switch (env) {
                    case 'local':
                        return 'https://localhost:5002/';
                    
                    case 'development':
                        if (window.location.host.indexOf('localhost') > -1)
                            return 'https://localhost:5002/';
                        return webApiUrl;
                    
                    case 'qa':
                        return webApiUrl;
                        
                    case 'qa-local':
                        if (window.location.host.indexOf('localhost') > -1)
                            return 'https://localhost:5002/';

                    case 'production':
                        return webApiUrl;
                }
    }

    function updateRefreshState(refresh, state) {
        refresh.state = state;
        return JSON.parse(JSON.stringify(refresh));
    }

    function checkLastLoginDate() {
                var sessionDuration = parseInt(import.meta.env.VITE_AUTO_LOG_OFF);

                if (userStore.isLogged()) {
                    var stringLoginDate = localStorage.getItem('lastLoginDate') != 'null' ? localStorage.getItem('lastLoginDate') : null;

                    if (stringLoginDate != null) {
                        var lastLoginDate = new Date(stringLoginDate);

                        if ((Math.abs(new Date() - lastLoginDate) / 36e5) > sessionDuration)
                            userStore.logOff();
                    }
                }
    }

    function translate(text, category = '', count = null) {
        if (count == null)
            return (category != '') ? t(category + '.' + text) : t(text);
        return (category != '') ? t(category + '.' + text, count, { count: count }) : t(text, count, { count: count });
    }

    function getFormBody(data) {
                var formBody = [];

                for (var property in data) {
                    var encodedKey = encodeURIComponent(property);
                    var encodedValue = encodeURIComponent(data[property]);
                    formBody.push(encodedKey + "=" + encodedValue);
                }

                return formBody.join("&");
    }

    function sleep(ms) {
        logStore.log('Sleeping', 'info');
        return new Promise(resolve => setTimeout(resolve, ms));
    }   
</script>

<style lang="scss"> 
    @use "sass:color";
    @use './assets/css/scss/main.scss'; 
</style>